import { render, staticRenderFns } from "./addFollowUp.vue?vue&type=template&id=1297d334&scoped=true&"
import script from "./addFollowUp.vue?vue&type=script&lang=js&"
export * from "./addFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./addFollowUp.vue?vue&type=style&index=0&id=1297d334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297d334",
  null
  
)

export default component.exports